<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进联盟"/>
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">联盟简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              广东省战略性产业人才培养与评价联盟成立于2021年9月，主要瞄准广东省20个战略性产业集群所需，以产业集群职业和岗位标准为引领，通过龙头企业等用人主体和院校等培养主体共同开发产业职业技能等级证书，形成招生、培训、认证、就业的技能人才有效培养供应链。联盟是以服务广东经济社会发展和战略产业发展为宗旨，以培养中高端技能型专业人才为根本，以广东技能人才培育和技能生态构建为使命，以优化社会培训与促进就业、优化技工院校教育为导向，实现政府、行业、企业、学校协同，建立新时代产培和产教融合体系，促进行业标杆性企业职业技能自主评价、促进产教协同和产培协同，提高社会培训水平、技工院校办学水平，实现资源互补、政策共享、专项培养、科学发展，提升联盟综合服务能力，从而促进战略产业的高速发展。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt/>
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course">
          <div class="top">
            <h3>联盟成果</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{ courseOne.Content }}</p>
                        <p>{{ courseOne.Year }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div class="content-culture">
          <h3>服务内容</h3>
          <h3>CULTURE</h3>
<!--          <p>产业就业培训基地和新技能学院建设</p>-->
          <span>新职业申报</span>
          <span>产业就业培训基地和新技能学院建设</span>
          <span>推动实施产业技能根基工程</span>
          <span>优势特色专业建设及教学资源开发</span>
          <span>国家职业技能标准开发</span>
          <span>国家级高技能人才培训基地建设</span>
        </div>
        <!-- 公司荣誉 -->
<!--        <div class="content-honor">-->
<!--          <div class="honor-big-img">-->
<!--            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">-->
<!--              <img v-lazy="dialogUrl" alt/>-->
<!--            </el-dialog>-->
<!--          </div>-->
<!--          <div class="top">-->
<!--            <h3>公司荣誉</h3>-->
<!--            <p>HONOR</p>-->
<!--            <div class="border"></div>-->
<!--          </div>-->
<!--          <ul class="honor-show">-->
<!--            <li v-for="(honor,index) in honorList" :key="index">-->
<!--              <img-->
<!--                  v-lazy="imgserver+honor.Img"-->
<!--                  @click="dialogTableVisible = true ;dialogUrl = imgserver + honor.Img;dialogTitle= honor.Remark"-->
<!--              />-->
<!--            </li>-->
<!--          </ul>-->
<!--          <p>点击图片查看大图</p>-->
<!--        </div>-->
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>生态链对接</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="team.Img"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img v-lazy="partner.Img" alt/>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {swiper, swiperSlide} from "vue-awesome-swiper";

import i1 from "@/assets/parn/01.jpg";
import i2 from "@/assets/parn/02.jpg";
import partner from "@/assets/img/partner.jpg";
import partner2 from "@/assets/parn/part.jpg";
import i3 from "@/assets/parn/03.jpeg";
import i4 from "@/assets/parn/04.jpeg";

export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [
        {Img:partner},
        {Img:partner2},
      ],
      courseList: [],
      teamItem: [
        {Img:i1},
        {Img:i2},
        {Img:i3},
        {Img:i4}
      ],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Honor/GetHonorAll"),
        this.$http.get("Enterprise/GetEnterpriseAll"),
        // this.$http.get(`Team/GetTeamAll`),
        // this.$http.get(`Course/GetCourseAll`)
      ])
      .then(
        this.$http.spread(
          (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
            // this.honorList = responseHonor.data;
            // this.partnerImg = responseEnterprise.data;
            // this.teamItem = responseTeam.data;
            this.loading = false;
          }
        )
      );
    this.loading = false;

    let courseList = [
      {
        "Id": 10,
        "Year": "2021年3月",
        "Content": "指导以广东电信为龙头的生态企业开展企业自主评价，并有1万2千左右的技能人才通过并拿到职业技能等级证书"
      },
      {
        "Id": 10,
        "Year": "2021年9月",
        "Content": "指导第一批和第二批行业协会和龙头企业申报社会培训评价组织。"
      },
      {
        "Id": 10,
        "Year": "2021年",
        "Content": "指导申报7个新职业（工种）申请，并经过部里层层论证全部通过。"
      },
      {
        "Id": 10,
        "Year": "2021年",
        "Content": "联盟联合国务院国资委中央企业人才开发交流平台——国投人力资源服务有限公司助力广东省第二届职业技能大赛。"
      }, {
        "Id": 10,
        "Year": "2021年",
        "Content": "2021、2022年联合联盟内单位报送 36 个职业（工种）开发行业企业评价规范和试题开发立项。"
      },{
        "Id": 10,
        "Year": "2022年",
        "Content": "2022年推进广东省“产教评”技能生态链试点建设。"
      },
      {
        "Id": 10,
        "Year": "2022年",
        "Content": `2022年，在广东人社支持下，联合巨量认证正式发布和启动"一试二证”。`
      }, {
        "Id": 10,
        "Year": "2023年",
        "Content": `2023年6月28日协办广东省“产教评”技能生态链建设对接会，该活动由广东省人社厅主办，有35家企业、21家院校参加，通过企企、企校签约，推动人才培养与产业发展深度融合。`
      },{
        "Id": 10,
        "Year": "2023年",
        "Content": `2023年与汕尾技师学院、云浮技师学院等多家院校开展人才联合培养合作。`
      },{
        "Id": 10,
        "Year": "2023年11月14日",
        "Content": `2023年11月14日，由联盟作为主要起草单位的《数据库运行管理员国家职业标准》通过终审。`
      },{
        "Id": 10,
        "Year": "2023年11月22日",
        "Content": `2023年11月22日协办第二届全国人力资源服务业发展大会产教评展示区，69家链主企业、生态企业提供大量优质招聘岗位，21家院校及学生参与招聘，获得各方高度认可。`
      },
    ]
    let groupCount = Math.ceil(courseList.length / 2);
    for (let i = 0; i < groupCount; i++) {
      let img2 = [];
      for (let j = 0; j < 2; j++) {
        if (courseList.length - 1 >= i * 2 + j) {
          img2.push(courseList[i * 2 + j]);
        }
      }
      this.courseList.push(img2);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  .section {
    width: 100%;

    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;

        .summary-left {
          width: 600px;

          .title {
            font-size: 25px;
            color: #e13834;
          }

          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }

          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;

        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;

          .swiper-container {
            height: 100%;
          }

          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;

            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }

              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;

                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;

        h3 {
          color: #3c6088;
          font-size: 26px;
        }

        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }

        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;

        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;

        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;

        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          li {
            //width: 107px;
            //height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }

  h3 {
    font-size: 30px;
  }

  p {
    font-size: 20px;
  }

  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: red;
  height: 3px;

  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}

.el-divider-active {
  background-color: #3c6088;
}

.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }
}
</style>
